<div class="custom-date datepicker-custom">
  <app-form-lablel
    [label]="label"
    style="margin-bottom: 3px;"
  ></app-form-lablel>
  <mat-form-field [ngStyle]="{ 'max-width': width }" appearance="outline">
    <input
      #input
      matInput
      readonly
      [max]="max"
      [disabled]="disabled"
      [matDatepicker]="pickerDesde"
      (dateChange)="onChange($event)"
      (focus)="picker.open()"
    />

    <mat-datepicker-toggle class="align-img" matSuffix [for]="pickerDesde">
    </mat-datepicker-toggle>

    <mat-datepicker #pickerDesde></mat-datepicker>
  </mat-form-field>
  <mat-error *ngIf="hasError">{{ messageError }}</mat-error>
</div>
